module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Services: " + _vm._s(_vm.migration.services))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Payments: " + _vm._s(_vm.migration.payments))])]), _vm._v(" "), (_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_provider),
      expression: "new_provider"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "name": "new_provider",
      "id": "new_provider",
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.new_provider)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_provider = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true
    },
    on: {
      "click": function($event) {
        return _vm.filter()
      }
    }
  }, [_vm._v("Filter")])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_provider_id),
      expression: "new_provider_id"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "new_provider_id",
      "id": "new_provider_id"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.new_provider_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.setProvider()
      }]
    }
  }, _vm._l((_vm.providers), function(provider) {
    return (provider.name.trim() != '') ? _c('option', {
      domProps: {
        "value": provider.id
      }
    }, [_vm._v(_vm._s(provider.id + ' - ' + provider.name + '(' + provider.provider_id + ')'))]) : _vm._e()
  }), 0)])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-disabled': _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.migrate()
      }
    }
  }, [_vm._v("Migrate")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-093ade30","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/customer/ProviderMigration.vue
// module id = 1063
// module chunks = 39